import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../controls/employee-report-selection-control.component";
import {ReportData} from "../../../../reports/report.data";

export class EmployeePhonListReportData extends ReportData<EmployeePhonListReportData> {
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @field unemployed: boolean = true;
    @field groupByPosition: boolean = false;

}
